import * as client_hooks from '../../../../src/hooks.client.ts';
import * as universal_hooks from '../../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64')
];

export const server_loads = [8];

export const dictionary = {
		"/": [11],
		"/added": [46],
		"/(app)/admin": [12,[2,3]],
		"/(app)/admin/accounts": [13,[2,3]],
		"/(app)/admin/audit": [14,[2,3]],
		"/(app)/admin/public-bot": [15,[2,3]],
		"/(app)/admin/showcase": [16,[2,3]],
		"/(app)/admin/tenants": [17,[2,3]],
		"/(app)/admin/tenants/[tenantId]": [18,[2,3]],
		"/capture/[name]": [47],
		"/demo": [48],
		"/guide": [49,[8]],
		"/guide/[slug]": [~50,[8]],
		"/legal/privacy": [51,[9]],
		"/legal/terms": [52,[9]],
		"/m/[guild]": [53,[10]],
		"/m/[guild]/card": [54,[10]],
		"/m/[guild]/giveaways/[giveaway]/[stage]": [55,[10]],
		"/m/[guild]/role": [56,[10]],
		"/pricing": [~57],
		"/products/analytics": [58],
		"/products/campaigns": [59],
		"/products/intelligence": [60],
		"/products/rewards": [61],
		"/products/workspace": [62],
		"/servers/[[tenant]]": [63],
		"/(app)/t/[tenant]": [19,[2,4],[,5]],
		"/(app)/t/[tenant]/analytics/[...view]": [26,[2,4],[,5]],
		"/(app)/t/[tenant]/billing": [27,[2,4],[,5]],
		"/(app)/t/[tenant]/campaigns/giveaways": [28,[2,4],[,5]],
		"/(app)/t/[tenant]/campaigns/giveaways/new": [31,[2,4],[,5]],
		"/(app)/t/[tenant]/campaigns/giveaways/templates/[template]": [32,[2,4],[,5]],
		"/(app)/t/[tenant]/campaigns/giveaways/[giveaway]": [29,[2,4],[,5]],
		"/(app)/t/[tenant]/campaigns/giveaways/[giveaway]/edit": [30,[2,4],[,5]],
		"/(app)/t/[tenant]/intelligence": [33,[2,4],[,5]],
		"/(app)/t/[tenant]/intelligence/annotations": [34,[2,4],[,5]],
		"/(app)/t/[tenant]/intelligence/annotations/rules/[[rule]]": [35,[2,4],[,5]],
		"/(app)/t/[tenant]/intelligence/briefing": [36,[2,4],[,5]],
		"/(app)/t/[tenant]/(leveling)/rewards/cards/rank": [20,[2,4,6],[,5]],
		"/(app)/t/[tenant]/(leveling)/rewards/earning": [21,[2,4,6],[,5]],
		"/(app)/t/[tenant]/(leveling)/rewards/earning/rules": [22,[2,4,6],[,5]],
		"/(app)/t/[tenant]/(leveling)/rewards/earning/settings": [23,[2,4,6],[,5]],
		"/(app)/t/[tenant]/rewards/images": [37,[2,4],[,5]],
		"/(app)/t/[tenant]/rewards/images/[image]": [38,[2,4],[,5]],
		"/(app)/t/[tenant]/(leveling)/rewards/level-up": [24,[2,4,6],[,5]],
		"/(app)/t/[tenant]/(leveling)/rewards/perks": [25,[2,4,6],[,5]],
		"/(app)/t/[tenant]/workspace/import": [40,[2,4],[,5]],
		"/(app)/t/[tenant]/workspace/requests": [41,[2,4,7],[,5]],
		"/(app)/t/[tenant]/workspace/requests/claims": [42,[2,4,7],[,5]],
		"/(app)/t/[tenant]/workspace/requests/entries": [43,[2,4,7],[,5]],
		"/(app)/t/[tenant]/workspace/requests/pictures": [44,[2,4,7],[,5]],
		"/(app)/t/[tenant]/workspace/requests/roles": [45,[2,4,7],[,5]],
		"/(app)/t/[tenant]/workspace/[[section]]": [39,[2,4],[,5]],
		"/welcome": [64]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);